import { type MCPServerInfo } from '../../types';

const AirtableServer: MCPServerInfo = {
  serverId: 'AIRTABLE',
  name: 'Airtable',
  slug: 'airtable',
  description: 'Airtable MCP Server',
  source: {
    sourceType: 'REPOSITORY',
    type: 'COMMUNITY',
    repositoryUrl: 'https://github.com/domdomegg/airtable-mcp-server',
    commitSha: 'latest',
    packageType: 'npm',
    packageName: 'airtable-mcp-server'
  },
  authenticationType: 'STATIC_CREDS',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: ['airtableApiKey'],
    properties: {
      airtableApiKey: {
        type: 'string',
        description: 'airtable API Key',
        sensitive: true
      }
    }
  },
  deprecated: true
};

export default AirtableServer;
